export class DropdownFiltersModel{
    fileType:string;
    proposal:string;
    domain:string;
}